export const MOBILE_MAP_HEIGHT = 0.6 // 60% height of layout

export const MAP_DESKTOP_PADDING_LEFT = 600

export const MOBILE_HEADER_HEIGHT = 59

export const MAP_DEFAULT_ZOOM = 14

export const MAP_KEY = 'AIzaSyAbXTG60zQvykZgKRmle13QmhoMgOT0_kc'
